// @ts-nocheck
/**
 * @param {{ panel?: boolean }} props
 * When `panel` is true, renders an in-place overlay (e.g. main content only) instead of full-viewport #loader.
 */
const Loader = ({ panel }) => {
  if (panel) {
    return (
      <div className="copilot-loader-panel" role="status" aria-live="polite" aria-busy="true">
        <div className="spinner-border text-primary" role="presentation" />
        <p className="mb-0 mt-3 small text-body">Working…</p>
      </div>
    );
  }

  return (
    <div id="loader">
      <div className="spinner spinner-border" role="status">
        <span className="sr-only">Loading...</span>
      </div>
      <div className="spinner message">
        <h6>Working...</h6>
      </div>
    </div>
  );
};

export default Loader;